import { useState } from "react";
import { Typography, Link } from "@mui/material";

export default function InlineReadMore({ text, charLimit = 100 }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = text.length > charLimit;

  const handleToggle = () => setExpanded(!expanded);

  const displayText =
    expanded || !isLong ? text : text.slice(0, charLimit).trim() + "...";

  return (
    <Typography
      variant="subtitle2"
      textAlign="left"
      sx={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        display: "inline",
        width: "100%",
      }}
    >
      {displayText}
      {isLong && (
        <>
          &nbsp;
          <Link
            component="button"
            onClick={handleToggle}
            underline="none"
            sx={{ fontWeight: 500, fontSize: "inherit" }}
          >
            {expanded ? "Read less" : "Read more"}
          </Link>
        </>
      )}
    </Typography>
  );
}
